// Installed app or browser tab? (S31 step 1 install guard, Tool Plan §4.14; IR-34.)
// The manifest asks for `standalone`; iOS Safari reports its home-screen app
// through `navigator.standalone`. A tab gets the guard and "just look around".

export function isInstalledApp(): boolean {
  const media = (query: string): boolean => typeof matchMedia === 'function' && matchMedia(query).matches
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true
  return iosStandalone || media('(display-mode: standalone)') || media('(display-mode: fullscreen)')
}
